import React from 'react'
import "../profile/Profile.css"

const contact = () => {
    return (
        <div className='Profile-main'>
            <div className="Profile-details">
                <p className="Profile-heading-info">Contact US</p>
                <div className="Profile-img-box-1">
                    <div className="input-box">
                        <div className="text-1">
                            <span className="Phone-number-text">Email</span>
                            <input
                                className="Mobile-number-1"
                                disabled
                                value="contact@magikmat.com"
                            />
                        </div>
                        <div className="text-1">
                            <span className="Phone-number-text">Phone Number</span>
                            <input
                                className="Mobile-number-1"
                                disabled
                                value="+91 – 72004 72006​"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default contact